"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RecordItem;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _AccountCircle2 = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Tooltip2 = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Delete2 = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    item: {
      marginTop: "0.5rem",
      padding: "0.5rem",
      border: "2px solid rgba(229, 231, 235, 1)",
      borderRadius: "0.5rem",
      cursor: "pointer",
      position: "relative",
      "&:hover": {
        border: "2px solid ".concat(theme.palette.primary.main)
      }
    }
  };
});
RecordItem.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    id: _propTypes["default"].string,
    type: _propTypes["default"].string
  })),
  item: _propTypes["default"].object,
  primaryField: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onClickDelete: _propTypes["default"].func
};

function RecordItem(_ref) {
  var _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$item = _ref.item,
      item = _ref$item === void 0 ? {} : _ref$item,
      primaryField = _ref.primaryField,
      onClick = _ref.onClick,
      onClickDelete = _ref.onClickDelete;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_Box2["default"], {
    key: item._id,
    onClick: onClick,
    className: classes.item
  }, onClickDelete && /*#__PURE__*/React.createElement(_Tooltip2["default"], {
    title: "Unlink record",
    arrow: true
  }, /*#__PURE__*/React.createElement(_IconButton2["default"], {
    style: {
      position: "absolute",
      top: 2,
      right: 2
    },
    size: "small",
    onClick: function onClick() {
      return onClickDelete(item);
    }
  }, /*#__PURE__*/React.createElement(_Delete2["default"], {
    fontSize: "small",
    color: "error"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      color: item[primaryField] || item.name ? "rgba(75, 85, 99, 1)" : "rgba(156, 163, 175, 1)",
      fontWeight: 500,
      letterSpacing: "0.025em"
    }
  }, item[primaryField] ? item[primaryField] : item.name || "Unnamed record"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "0.5rem",
      display: "flex"
    }
  }, fields === null || fields === void 0 ? void 0 : fields.filter(function (item) {
    return !item.isPrimary && item.type !== "linkToRecord";
  }).slice(0, 4).map(function (val) {
    var _item$val$name;

    return /*#__PURE__*/React.createElement("div", {
      key: val.id,
      style: {
        width: "".concat(100 / 4, "%")
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "0.65rem",
        letterSpacing: "0.05em",
        color: "rgba(156, 163, 175, 1)"
      }
    }, val.name.toUpperCase()), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        marginTop: "0.25rem",
        width: "100%",
        height: 24,
        overflow: "hidden"
      }
    }, item[val.name] !== null ? Array.isArray(item[val.name]) ? item[val.name].length > 0 ? val.type === "attachment" ? item[val.name].slice(0, 1).map(function (img, id) {
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        style: {
          height: "100%",
          border: "2px solid rgba(209, 213, 219,1)",
          borderRadius: "0.25rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: img.url,
        alt: img.fileName,
        style: {
          maxHeight: "100%"
        }
      }));
    }) : val.type === "multiSelect" ? item[val.name].map(function (opt, id) {
      return /*#__PURE__*/React.createElement(_Chip2["default"], {
        key: id,
        size: "small",
        color: "primary",
        label: opt.value,
        style: {
          marginLeft: id > 0 ? "0.25rem" : 0
        }
      });
    }) :
    /*#__PURE__*/
    // link to record
    React.createElement("div", {
      style: {
        marginTop: "0.25rem",
        fontSize: "0.875rem",
        width: "100%"
      }
    }, item[val.name].length > 0 && item[val.name].map(function (record, id) {
      return /*#__PURE__*/React.createElement("div", {
        key: id
      }, record.slice(0, 10).trim() + "...");
    })) : null : val.type === "createdBy" || val.type === "updatedBy" ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(_AccountCircle2["default"], {
      style: {
        fontSize: "1.25rem",
        color: "#20C933"
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: "0.25rem"
      }
    }, item[val.name].firstName)) : val.type === "singleSelect" ? (_item$val$name = item[val.name]) !== null && _item$val$name !== void 0 && _item$val$name.value ? /*#__PURE__*/React.createElement(_Chip2["default"], {
      size: "small",
      label: item[val.name].value,
      color: "primary"
    }) : null : val.type === "checkBox" ? /*#__PURE__*/React.createElement(_Checkbox2["default"], {
      checked: item[val.name],
      size: "small",
      color: "primary",
      style: {
        padding: 0
      }
    }) : val.type === "currency" ? /*#__PURE__*/React.createElement("div", null, val.options.currencySymbol, item[val.name].toFixed(val.options.precision)) : val.type === "percent" ? /*#__PURE__*/React.createElement("div", null, (item[val.name] * 100).toFixed(val.options.precision), "%") : typeof item[val.name] === "string" ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "0.25rem",
        fontSize: "0.875rem"
      }
    }, item[val.name].length > 10 ? item[val.name].slice(0, 10).trim() + "..." : item[val.name]) : null : null));
  })));
}